

import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers/index';
import { routerMiddleware } from 'react-router-redux';

export default function configureStore(history, initialState) {
  const routesMiddleware = routerMiddleware(history);
  const middleware = [thunkMiddleware, routesMiddleware];

  const store = createStore(rootReducer, initialState, compose(applyMiddleware(...middleware)));

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
